import { factory } from '@store/utils'

export default {
  auto: '*',

  store: {
    state: {
      specTypeOptionTypes: {
        SINGLE: 'SINGLE',
        MULTIPLE: 'MULTIPLE',
      },
    },

    getters: {
      specTypeOptionTypes: state => state.specTypeOptionTypes,
      specTypes: (_, { query }) => query('specType'),

      specTypeFactory: factory(() => ({
        chartTemplate: null,
        fields: [],
        key: null,
        name: null,
        noteLabel: null,
        options: [],
        optionsType: 'SINGLE',
      })),
    },
  },
}
